// Per-process abuse damping, not a distributed quota.
export class AudienceRateLimiter {
  private readonly attempts = new Map<string, number[]>();

  constructor(
    private readonly limit = 5,
    private readonly windowMs = 60 * 60 * 1_000,
  ) {}

  isLimited(key: string, nowMs: number): boolean {
    const cutoff = nowMs - this.windowMs;
    const recent = (this.attempts.get(key) ?? []).filter(
      (timestamp) => timestamp > cutoff,
    );
    if (recent.length >= this.limit) {
      this.attempts.set(key, recent);
      return true;
    }
    recent.push(nowMs);
    this.attempts.set(key, recent);
    return false;
  }
}
